import { SxProps, Theme } from '@mui/system';

// hooks
import useAuth from 'hooks/useAuth';
import useCurrency from 'hooks/useCurrency';

// components
import Label from 'components/Label';

const KycButton = ({ sx = {}, dataTestId = 'kyc-button' }: { sx: SxProps<Theme>; dataTestId?: string }) => {
  const { currency } = useCurrency();
  const currencySymbol: string = currency?.symbol;

  const { isAuthenticated, userCredit } = useAuth();
  if (!isAuthenticated || !userCredit) return null;

  const userCreditData = userCredit ?? {};

  // Safely extract and parse values
  const paymentDays = Number(userCreditData?.paymentDays) || 0;
  const upfrontPaymentPercentage = Number(userCreditData?.upfrontPaymentPercentage) || 0;
  const creditLimit = Number(userCreditData?.creditLimit);

  const upfrontText =
    upfrontPaymentPercentage && upfrontPaymentPercentage > 0 ? `${upfrontPaymentPercentage}% upfront | ` : '';
  const creditLimitText = `${currencySymbol}${creditLimit} credit`;
  const paymentDaysText = paymentDays && paymentDays > 0 ? ` | ${paymentDays} days` : '';

  const buttonText = upfrontText + creditLimitText + paymentDaysText;

  return (
    <Label variant="filled" type="NEW" data-testid={dataTestId} sx={{ ...sx }}>
      {buttonText}
    </Label>
  );
};

export default KycButton;
